module.exports = __webpack_public_path__ + "media/images/mobile/logo/menu-logo-550f1753ea4a1426d5abfc04b3aa6ce4.png";